import { InvoicePaymentCollection, InvoicePaymentModel, ValidateInvoicePayment } from "@auer-steel/Services/InvoicePaymentService";
import { getWalletsList } from "@auer-steel/Services/WalletService";
import { AuerActions, AuerState } from "@auer-steel/Store/AuerState";
import { convertToApiParameter, getInvoicePaymentDiscountAmount } from "@auer-steel/Utilities/PayInvoiceUtilities";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getBillTo } from "@insite/client-framework/Services/CustomersService";
import { getInvoice } from "@insite/client-framework/Services/InvoiceService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getInvoiceState } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{}, {}, DispatchProp<AuerActions>>;

export const LoadAchWallets: HandlerType = async props => {
    props.dispatch({ type: "Pages/PayInvoice/UpdateAchWalletsAreLoading", parameter: true });
    const wallets = await getWalletsList();

    if (wallets.successful) {
        props.dispatch({ type: "Pages/PayInvoice/UpdateAchWallets", parameter: wallets.result });
    }
    
    props.dispatch({ type: "Pages/PayInvoice/UpdateAchWalletsAreLoading", parameter: false });
};

export const chain = [LoadAchWallets];

const loadAchWallets = createHandlerChainRunner(chain, "LoadAchWallets");
export default loadAchWallets;
